import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";
import { History } from "history";
import businessStepReducer from "./containers/BusinessStep/reducer";
import WidgetSelectionStepReducer from "./containers/WidgetSelectionStep/reducer";
import categoriesStepReducer from "./containers/CategoriesStep/reducer";
import wizardReducer from "./containers/Wizard/reducer";

export default (history: History) =>
  combineReducers({
    router: connectRouter(history),
    businessStep: businessStepReducer,
    widgetSelectionStep: WidgetSelectionStepReducer,
    categoriesStep: categoriesStepReducer,
    wizard: wizardReducer,
  });
